import { Box, Typography } from "@husqvarna/ui-core";
import { useIntl } from "react-intl";
import { ProjectStatus } from "../../models/Enums";
import "./ProjectStatusTag.scss";

export type ProjectStatusTagProps = {
    projectStatus : ProjectStatus;
    textAlign?: "left" | "center" | "right";
}

const ProjectStatusTag = ({projectStatus, textAlign = "left"} : ProjectStatusTagProps) => {
    const intl = useIntl();

    const getProjectStatusText = (projectStatus: ProjectStatus): string => {
        switch (projectStatus) {
            case ProjectStatus.Completed:
                return intl.formatMessage({id:'project.status.completed', defaultMessage:"Completed"});
            case ProjectStatus.InProgress:
                return intl.formatMessage({id:'project.status.inProgress', defaultMessage:"In progress"});
            case ProjectStatus.Empty:
                return intl.formatMessage({id:'project.status.empty', defaultMessage:"Empty"});
        }
    }

    return (
        <Box textAlign={textAlign}>
            <Typography
                text={getProjectStatusText(projectStatus)}
                className={"project-status-tag project-status-" + projectStatus}
                variant="Label"
                tag="span" />
        </Box>
    )
}

export default ProjectStatusTag;